export default __webpack_public_path__ + "locales/fi/SharingPanel.json?hash=39c3d48ba9fd812acfe6fcc23db1e2eb";